/**
 * Route subtree mounted at `/w/:slug/tables` from `App.tsx`. Pages are
 * code-split via `React.lazy` + `<Suspense>` so the data-tables bundle
 * doesn't bloat the initial dashboard load. Mirrors `agents/routes.tsx`.
 */

import { lazy, Suspense, type ReactElement } from "react";
import { Route } from "react-router";

import { RouteFallback } from "../components/route-fallback";

const TablesListPage = lazy(() =>
  import("./pages/TablesListPage").then((m) => ({ default: m.TablesListPage })),
);
const TableDetailPage = lazy(() =>
  import("./pages/TableDetailPage").then((m) => ({ default: m.TableDetailPage })),
);
const QueryPlaygroundPage = lazy(() =>
  import("./pages/QueryPlaygroundPage").then((m) => ({ default: m.QueryPlaygroundPage })),
);
const StoredQueryListPage = lazy(() =>
  import("./pages/StoredQueryListPage").then((m) => ({ default: m.StoredQueryListPage })),
);
const StoredQueryEditorPage = lazy(() =>
  import("./pages/StoredQueryEditorPage").then((m) => ({ default: m.StoredQueryEditorPage })),
);
const ConnectorSetupPage = lazy(() =>
  import("./pages/ConnectorSetupPage").then((m) => ({ default: m.ConnectorSetupPage })),
);
const LogsViewerPage = lazy(() =>
  import("./pages/LogsViewerPage").then((m) => ({ default: m.LogsViewerPage })),
);

function withSuspense(node: ReactElement): ReactElement {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

export function tablesRoutes() {
  return (
    <>
      <Route path="tables" element={withSuspense(<TablesListPage />)} />
      <Route path="tables/queries" element={withSuspense(<StoredQueryListPage />)} />
      <Route path="tables/queries/new" element={withSuspense(<StoredQueryEditorPage />)} />
      <Route path="tables/queries/:queryId" element={withSuspense(<StoredQueryEditorPage />)} />
      <Route path="tables/connectors" element={withSuspense(<ConnectorSetupPage />)} />
      <Route path="tables/logs" element={withSuspense(<LogsViewerPage />)} />
      <Route path="tables/:tableId" element={withSuspense(<TableDetailPage />)} />
      <Route path="tables/:tableId/playground" element={withSuspense(<QueryPlaygroundPage />)} />
    </>
  );
}
